import * as React from 'react';

import { Layout as AntLayout } from 'antd';

const { Content } = AntLayout;

export type LayoutContentProps = {
  className?: string;
} & React.ComponentProps<typeof Content>;

const LayoutContent = ({ className, ...props }: LayoutContentProps) => {
  const classNames = [className, 'layout-content', 'container', 'mx-auto'];
  return <Content {...props} className={classNames.join(' ')} />;
};

LayoutContent.defalutProps = {
  className: undefined,
};

export default LayoutContent;
